import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Notification } from '../../components/Notification';
import { TEMPLATE } from '../../utils/apiEndpoints';
import clientService from '../../apiClient';

const initialState = {
  loading: {
    templates: false,
  },
  templates: [],
  templateId: null,
  openCreateDocumentModal: false,
  openRenameFileModal: false,
  clickedDocOrFolderId: null,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplateId: (state, action) => {
      state.templateId = action.payload;
    },
    setOpenCreateDocumentModal: (state, action) => {
      state.openCreateDocumentModal = action.payload;
    },
    setOpenRenameFileModal: (state, action) => {
      state.openRenameFileModal = action.payload;
    },
    setClickedDocOrFolderIdInStore: (state, action) => {
      state.clickedDocOrFolderId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTemplates.pending, (state) => {
      state.loading.templates = true;
    });
    builder.addCase(fetchTemplates.fulfilled, (state, action) => {
      state.loading.templates = false;
      state.templates = action.payload;
    });
    builder.addCase(fetchTemplates.rejected, (state, action) => {
      state.loading.templates = false;
      Notification.error('Error happened while fetching templates', action?.payload?.error);
    });
  },
});

export const fetchTemplates = createAsyncThunk(
  'cms/fetchTemplates',
  async ({ endpoint, params, callback }, { rejectWithValue }) => {
    try {
      const response = await clientService.get(`${TEMPLATE}${endpoint ? endpoint : ''}`, { params: params || {} });
      callback?.(response?.data);
      return response?.data;
    } catch (error) {
      return rejectWithValue({ error: err?.data?.error?.message });
    }
  }
);

export default templateSlice.reducer;
export const { setTemplateId, setOpenCreateDocumentModal, setOpenRenameFileModal, setClickedDocOrFolderIdInStore } =
  templateSlice.actions;
